'use strict';

export const formatDate = (date = Date.now(), format = 'yyyy-MM-dd hh:mm', separator) => {
    date = new Date(date);
    // let result = '';
    // if (/yyyy/i.test(format)) {
    //     result += `${date.getFullYear()}` + (separator || '年')
    // }
    // if (/MM/.test(format)) {
    //     let month = date.getMonth() + 1;
    //     month = month < 10 ? `0${month}` : month;
    //     result += `${month}` + (separator || '月')
    // }
    // if (/dd/i.test(format)) {
    //     let day = date.getDate();
    //     day = day < 10 ? `0${day}` : day;
    //     result += `${day}` + (separator ? '' : '日')
    // }
    // if (/hh/i.test(format)) {
    //     let hours = date.getHours();
    //     hours = hours < 10 ? `0${hours}` : hours;
    //     result += ` ${hours}`
    // }
    // if (/mm/.test(format)) {
    //     let minutes = date.getMinutes();
    //     minutes = minutes < 10 ? `0${minutes}` : minutes;
    //     result += `:${minutes}`
    // }
    // if (/ss/.test(format)) {
    //     let seconds = date.getSeconds();
    //     seconds = seconds < 10 ? `0${seconds}` : seconds;
    //     result += `:${seconds}`
    // }
    // return result;
    let year = date.getFullYear() // 年份
    let month = date.getMonth() + 1 // 月份
    let day = date.getDate() // 日
    let hours24 = date.getHours() // 小时
    let hours = hours24 % 12 === 0 ? 12 : hours24 % 12
    let minutes = date.getMinutes() // 分
    let seconds = date.getSeconds() // 秒
    let milliseconds = date.getMilliseconds() // 毫秒
    let map = {
      yyyy: year,
      MM: ('0' + month).slice(-2),
      M: month,
      dd: ('0' + day).slice(-2),
      d: day,
      HH: ('0' + hours24).slice(-2),
      H: hours24,
      hh: ('0' + hours).slice(-2),
      h: hours,
      mm: ('0' + minutes).slice(-2),
      m: minutes,
      ss: ('0' + seconds).slice(-2),
      s: seconds,
      S: milliseconds
    }
    return format.replace(/y+|M+|d+|H+|h+|m+|s+|S+/g, function (str) {
      return map[str]
    })
}


// WEBPACK FOOTER //
// ./src/common/js/date_format.js